<template>
  <div class="FebSnowPromoBanner">
    <div
      v-if="image?.responsiveImage"
      class="FebSnowPromoBanner__img-wrapper"
    >
      <DatoCmsImage
        class="FebSnowPromoBanner__img"
        :data="image.responsiveImage"
        :lazy-load="false"
        :focal-point="image.focalPoint"
        picture-class="FebSnowPromoBanner__picture"
        :picture-style="{
          objectFit: 'cover'
        }"
      />
    </div>

    <div class="FebSnowPromoBanner__copy">
      <BaseHeading
        :class="[
          'FebSnowPromoBanner__header',
          'FebSnowPromoBanner__header--black'
        ]"
        size="h1"
        tag="h3"
      >
        Snow Series&trade; Flash Sale.
      </BaseHeading>

      <BaseHeading
        size="h3"
        class="FebSnowPromoBanner__subheader"
      >
        A Free Pair of Goggles with Every Pair.
        <span class="FebSnowPromoBanner__subheader--faded">
          While stocks last.
        </span>
      </BaseHeading>
    </div>
  </div>
</template>

<script>
import { Image as DatoCmsImage } from 'vue-datocms'

export default {
  name: 'FebSnowPromoBanner',

  components: {
    DatoCmsImage
  },

  props: {
    image: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style lang="postcss" scoped>
.FebSnowPromoBanner {
  @apply relative flex items-center overflow-hidden rounded-[10px] px-md py-sm md:px-lg md:py-md;

  &__copy {
    @apply z-[1];
  }

  &__header {
    @apply text-[26px] md:text-[38px];

    &--white {
      @apply text-white;
    }

    &--black {
      @apply text-off-black;
    }
  }

  &__subheader {
    @apply text-[18px] md:text-[30px] text-white;

    &--faded {
      @apply opacity-70;
    }
  }

  &__img-wrapper {
    @apply absolute top-0 right-0 bottom-0 left-0;
  }

  &__img {
    @apply w-full h-full;
  }
}
</style>